import {
  Card, CardContent, Typography, makeStyles, Chip,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  title: {
    fontWeight: '600',
    float: 'left',
  },
  label: {
    float: 'right',
  },
  successStat: {
    color: theme.palette.success.main,
  },
  failStat: {
    color: theme.palette.error.main,
  },
  muteStat: {
    color: theme.palette.grey[700],
  },
  muted: {
    color: theme.palette.grey[500],
    fontWeight: 700,
  },
  Stat: {
    color: theme.palette.success.main,
  },
  faded: {
    fontWeight: 700,
    color: theme.palette.grey[700],
    textAlign: 'left',
  },
}));

const CommonCard = ({
  children, title, label, changeType, stat, description, change,
}) => {
  const classes = useStyles();
  let changeClass = '';
  switch (changeType) {
    case null:
      changeClass = classes.muteStat;
      break;
    case 'positive':
      changeClass = classes.successStat;
      break;
    case 'negative':
      changeClass = classes.failStat;
      break;
    default:
      break;
  }
  return (
    <Card className={classes.root}>
      <CardContent>
        <div className="row">
          <div className="col-12">
            <Typography
              className={classes.title}
              gutterBottom
            >
              {title}
            </Typography>
            {label && (
            <Chip
              className={classes.label}
              size="small"
              label={label}
              color="primary"
            />
            )}
          </div>
        </div>
        {children === null ? (
          <>
            <div className="row">
              <div className="col-12">
                <Typography variant="h5" className="text-left dark-bg">
                  {stat}
                </Typography>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-left">
                <Typography className={changeType ? classes.faded : classes.muted} align="left">
                  <span className={changeClass}>{change || ''}</span>
                  {' '}
                  {description || ''}
                </Typography>
              </div>
            </div>
          </>
        ) : children}
      </CardContent>
    </Card>
  );
};

CommonCard.defaultProps = {
  label: null,
  changeType: null,
  children: null,
  stat: 0,
  description: '',
  change: 0,
};

export default CommonCard;
